import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { GetMonitorOrdersResponseAdmin } from '@/backend/market'
import { OrderLiveResponseEntity } from '@/features/trackOrderTwo/domain/entities/orderEntities/OrderLiveResponseEntity'
import { OrderLiveModel } from './OrderLiveModel'

export class OrderLiveResponseModel extends OrderLiveResponseEntity {
  constructor(dataDto: GetMonitorOrdersResponseAdmin) {
    const orderLiveModels = dataDto.orders?.map((order) => new OrderLiveModel(order))
    super()
    mapEntityProperties<OrderLiveResponseEntity>(this, dataDto, {
      map: {
        orders: orderLiveModels
      }
    })
  }
}
